import { useMutation } from '@apollo/client';

import DeletePaymentMethodMutation from 'bundles/account-settings/queries/DeletePaymentMethodMutation.graphql';
import type {
  DeletePaymentMethodMutation as DeletePaymentMethodMutationData,
  DeletePaymentMethodMutationVariables,
} from 'bundles/account-settings/queries/__generated__/DeletePaymentMethodMutation';

export function useDeletePaymentMethod() {
  const [executeMutation] = useMutation<DeletePaymentMethodMutationData, DeletePaymentMethodMutationVariables>(
    DeletePaymentMethodMutation,
    { context: { clientName: 'gatewayGql' } }
  );

  const deletePaymentMethod = ({ paymentMethodId }: { paymentMethodId: string }) => {
    return executeMutation({
      variables: {
        input: {
          id: paymentMethodId,
        },
      },
    });
  };

  return {
    deletePaymentMethod,
  };
}
